<template lang="pug">
    section#experiencia
        .wrapper
            h2 Viva essa experiência na FAEL!
            p.sub Arraste ou clique para conhecer o nosso compromisso com você.
            .descricoes
                div.descricao.faelPlus(@click="$eventBus.$emit('openExperiencia', 'faelPlus')")
                    h3 
                        |FAEL
                        span +
                        br
                        |Muito além do tradicional.
                    p
                        |Programas com conteúdo exclusivo e totalmente gratuitos ao aluno FAEL.
                Drag.drag
                div.descricao.faelflix(@click="$eventBus.$emit('openExperiencia', 'faelflix')")
                    h3
                        |FAELFLIX 
                        br
                        |Conhecimento extra a um play de distância.
                    p
                        |Aluno FAEL com acesso a mais de 100 cursos, pagando menos.
            button(@click="$parent.goTo('#page')")
                img(:src="require('@images/icons/arrowDown.png')")
</template>

<script>
import Drag from '@components/Drag/Drag.vue'

export default {
    name: "experiencia",
    components: {
        Drag,
    }
}
</script>

<style lang="stylus" scoped src="./Experiencia.styl"></style>